"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _ToggleModule = _interopRequireDefault(require("./Toggle.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Note:
 * Do not wrap Toggle in a label. For simplicity's sake, Toggle uses an
 * internal label tag to handle click delegation to the hidden input, and
 * nesting labels is a bad idea.
 */

const Toggle = exports.Toggle = /*#__PURE__*/React.forwardRef((_ref, forwardRef) => {
  let {
    name = 'toggle',
    value = '',
    classNames,
    children,
    disabled,
    checked,
    focused,
    onChange,
    ariaLabel,
    labelPosition = 'right',
    ...props
  } = _ref;
  const toggleInput = /*#__PURE__*/React.createRef();
  // @ts-ignore - TS2322 - Type 'HTMLInputElement | null' is not assignable to type 'HTMLInputElement'.
  React.useImperativeHandle(forwardRef, () => toggleInput.current);
  const handleOnChange = () => {
    if (!disabled) {
      onChange && onChange({
        value,
        checked: !checked
      });
    }
  };
  const onWrapClickHandler = e => {
    e.nativeEvent.stopImmediatePropagation();
    toggleInput.current?.click();
  };
  React.useEffect(() => {
    if (toggleInput.current && focused) {
      toggleInput.current.focus();
    }
  }, [focused]);
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_ToggleModule.default.container, {
      [_ToggleModule.default.disabled]: disabled
    }, classNames?.wrapper),
    onClick: onWrapClickHandler
  }, labelPosition === 'left' && React.Children.count(children) > 0 && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_ToggleModule.default.toggleLabel, classNames?.label)
  }, children), /*#__PURE__*/React.createElement("span", {
    className: _ToggleModule.default.toggleWrap
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    name: name,
    value: value,
    checked: checked,
    onChange: handleOnChange,
    ref: toggleInput,
    disabled: disabled,
    "aria-label": ariaLabel || children
  }, props)), /*#__PURE__*/React.createElement("span", {
    className: (0, _classify.default)(_ToggleModule.default.toggle, {
      [_ToggleModule.default.disabledButton]: disabled
    })
  })), labelPosition === 'right' && React.Children.count(children) > 0 && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_ToggleModule.default.toggleLabel, classNames?.label)
  }, children));
});

// @ts-ignore - TS2339 - Property 'name' does not exist on type 'unknown'.
// @ts-ignore - TS2339 - Property 'displayName' does not exist on type 'unknown'.
Toggle.name = Toggle.displayName = 'Toggle';